<script lang="ts" setup>
import IconLogo from '@shared/components/logo/IconLogo.vue';
</script>

<template>
  <div class="min-h-full bg-default text-neutral">
    <div class="mx-auto h-full w-[700px] pt-[100px]">
      <RouterLink to="/" class="text-inherit">
        <IconLogo show-text class="mx-auto mb-[48px]" />
      </RouterLink>

      <slot />
    </div>
  </div>
</template>
